import React from "react";
import s from '../../TablePage.module.scss'
import { Close, Done } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";


export const RawOfTableCollection = (props) => {
    const { t } = useTranslation()
    const { is_staff } = useSelector(state => state.auth)

    return (
        <tr className={s.raw_of_table}>
            {is_staff && <td><input id={props.id} type="checkbox" checked={props.check} onChange={(e) => props.handleClick(e, props.id)} /></td>}
            <td className={s.raw_id}>{props.id}</td>
            {/* <td style={{ maxWidth: '100px' }}>{props.name}</td> */}
            <td className={s.birds_recognized}>
                <div className={s.birds_recognized_main}>{props.recognized_birds_species?.[0]}</div>
                {props.recognized_birds_species?.length > 1 && <div className={s.birds_recognized_hidden}>{props.recognized_birds_species?.join(', ')}</div>}
            </td>
            <td>{props.validated ?
                <Done className={s.icon_done} />  :
                <Close className={s.icon_close} />}</td>
            <td><audio className={s.table__audio} src={props.audiorecord_local} controls></audio></td>
            {/* <td><a target="blank" href={props.audiorecord_xeno_canto}>
            {props.audiorecord_xeno_canto ? 'Xeno-Canto link'
            :  <Close className={s.icon_close} />}</a>
            </td> */}
            {/* <td>{props.audio_quality_tag}</td> */}
            <td>
                <a target="blank" href={props.audio_spectrogram}>
                    {props.audio_spectrogram ? t('openSpectrogram')
                        :  <Close className={s.icon_close} />}
                </a>
            </td>
            <td>{props.created_at}</td>
            <td>{props.updated_at}</td>
            <td><NavLink to={`/map/${props.id}`} className={s.button__approve}>
                {t('map')}
                </NavLink>
            </td>
        </tr>
    )
}